import { ADD_SURVEY, GET_SURVEY_COUNT, GET_SURVEY_DETAIL, GET_SURVEY_REPORT, GET_TAB_VALUE_HEADER } from "shared/constants/ActionTypes";

const initialState = {
    listReport: null,
    listCount: null,
    detail: null
};

const taskManagementReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_SURVEY:
            return {
                ...state,
            }
        case GET_SURVEY_REPORT:
            return {
                ...state,
                listReport: action.payload,
            }
        case GET_SURVEY_COUNT:
            return {
                ...state,
                listCount: typeof action.payload === 'string' ? null : action.payload,
            }
        case GET_SURVEY_DETAIL:
            return {
                ...state,
                detail: action.payload,
            }
        default:
            return {
                ...state
            }
    }
};

export default taskManagementReducer;